import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GlobalStoreService {
  isNavCollapsed = new BehaviorSubject(false);
  actionProgram = new BehaviorSubject({});
  programs = new BehaviorSubject([]);
  bonusPrograms = new BehaviorSubject([]);
  ageGroups = new BehaviorSubject([]);
  quotients = new BehaviorSubject([]);
  materialTypes = new BehaviorSubject([]);
  languages = new BehaviorSubject([]);
  books = new BehaviorSubject([]);
  toys = new BehaviorSubject([]);
  settings = new BehaviorSubject([]);

  private storeMap: Record<string, BehaviorSubject<any>> = {
    materialTypes: this.materialTypes,
    languages: this.languages,
  };

  getStoreByKey(key: string): BehaviorSubject<any> | undefined {
    return this.storeMap[key];
  }

  setNavCollapsed(value = false) {
    this.isNavCollapsed.next(value);
  }
}